<template>
  <nav class="breadcrumb" v-if="crumbs.length > 1">
    <ol>
      <li v-for="(crumb, index) in crumbs" :key="crumb.path">
        <router-link
          v-if="index < crumbs.length - 1"
          :to="index === 0 ? homeRoute : crumb.path"
        >
          {{ crumb.name }}
        </router-link>
        <span v-else>{{ crumb.name }}</span>
        <span v-if="index < crumbs.length - 1" class="separator">/</span>
      </li>
    </ol>
  </nav>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'

const route = useRoute()

/** Explicit absolute route for Home so the link is never resolved relative to current path (e.g. /farmonaut). */
const homeRoute = { path: '/home' }

const crumbs = computed(() => {
  const pathArray = route.path.split('/')
  const crumbList = [{ name: 'Home', path: '/home' }]

  let path = ''
  pathArray.forEach(segment => {
    if (segment) {
      path += `/${segment}`
      crumbList.push({
        name: segment.charAt(0).toUpperCase() + segment.slice(1),
        path
      })
    }
  })

  return crumbList
})
</script>

<style scoped>
.breadcrumb {
  padding: 10px 20px;
  background-color: white;
  border-bottom: 1px solid #eee;
}

.breadcrumb ol {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-wrap: wrap;
}

.breadcrumb li {
  display: flex;
  align-items: center;
}

.breadcrumb a {
  color: #42b983;
  text-decoration: none;
}

.breadcrumb a:hover {
  text-decoration: underline;
}

.breadcrumb .separator {
  color: #666;
  margin: 0 8px;
}
</style> 